<template>
    <div>
        <div class="header-return">
          <el-row>
            <el-form :inline="true" :model="formInline" class="demo-form-inline select-wrap"
                     :size="GCONFIG.styleElFormSize">
              <el-form-item label="">
                <el-button type="text" icon="el-icon-arrow-left" @click="returnHistory">返回</el-button>
              </el-form-item>
              <el-form-item label="短链接码">
                <el-input v-model="formInline.urlKey" placeholder="输入短链接码查询"></el-input>
              </el-form-item>
              <el-form-item label="长链接">
                <el-input v-model="formInline.url" placeholder="输入长链接查询"></el-input>
              </el-form-item>
              <el-form-item label="名称">
                <el-input v-model="formInline.urlName" placeholder="输入名称查询"></el-input>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" @click="getList">查询</el-button>
                <el-button type="success" @click="add()" class="header-btn">新建</el-button>
              </el-form-item>
            </el-form>
          </el-row>
<!--            <el-row :gutter="20">-->
<!--                <el-col :span="2">-->
<!--                    <el-button type="text" icon="el-icon-arrow-left" @click="returnHistory">返回</el-button>-->
<!--                </el-col>-->
<!--                <el-col :span="2" :offset="20">-->
<!--                    <el-button type="primary" @click="add()" size="mini" class="header-btn">新建</el-button>-->
<!--                </el-col>-->
<!--            </el-row>-->
        </div>
        <el-table :data="list" stripe border center :size="GCONFIG.styleTableSize">
            <el-table-column type="index" label="序号" width="50"></el-table-column>
            <el-table-column label="短连接" prop="urlKey"></el-table-column>
            <el-table-column label="长连接" prop="url"></el-table-column>
            <el-table-column label="名称" prop="urlName"></el-table-column>
            <el-table-column prop="createTime" label="创建时间">
                <template slot-scope="scope">
                    <span>{{formatDate(scope.row.createTime)}}</span>
                </template>
            </el-table-column>
            <el-table-column prop="expiredTime" label="过期时间">
                <template slot-scope="scope">
                    <span>{{formatDate(scope.row.expiredTime)}}</span>
                </template>
            </el-table-column>
            <el-table-column label="操作" fixed="right" width="220">
                <template slot-scope="scope">
                    <el-button-group>
                        <el-button type="success" size="mini" v-show="scope.row.operateType" @click="edit(scope.row)">修改</el-button>
                        <el-button type="danger" size="mini" v-show="false" @click="handleDel(scope.row)">删除</el-button>
                    </el-button-group>
                </template>
            </el-table-column>
        </el-table>
        <div class="pagination-wrap">
            <el-pagination
                    background
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="formInline.currentPage"
                    :page-sizes="GCONFIG.pageSizes"
                    :page-size="formInline.pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="recordsTotal">
            </el-pagination>
        </div>
        <el-dialog title="设置" :visible.sync="showDialog">
            <el-form :model="model" label-width="120px">
                <el-form-item label="注意">
                    <el-alert title="这里只能生成H5连接,修改长连接url才会保存，单独修改名称不保存 " type="success" :closable="false">
                    </el-alert>
                </el-form-item>
                <el-form-item label="长连接url" prop="url" :required="true">
                    <el-input v-model="model.url" placeholder="长连接url"></el-input>
                </el-form-item>
                <el-form-item label="名称" prop="url" :required="true">
                    <el-input v-model="model.urlName" placeholder="连接名称说明"></el-input>

                </el-form-item>
                <el-form-item label="urlKey" prop="urlKey" v-show="false">
                    <el-input v-model="model.urlKey" placeholder="长连接url"></el-input>
                </el-form-item>

                <el-form-item>
                    <el-button @click="showDialog = false">取 消</el-button>
                    <el-button type="primary" @click="save()" class="header-btn">
                        保存
                    </el-button>
                </el-form-item>
            </el-form>
        </el-dialog>
    </div>
</template>
<script>
    //导入 HTTP请求方法
    import {
        getShortUrlListApi, deleteShortLinkApi, saveShortLinkApi
    } from '../../api/api';
    export default {
        data() {
            return {
                showDialog: false,
                formInline: {
                    currentPage: 1,
                    pageSize: 20,
                    urlKey: "",
                    urlName: "",
                    url: ""
                },
                list: [],
                model: {
                    urlKey: '',
                    urlName:'',
                    url:''
                },
                loading: true,
                recordsTotal: 0,
                oldName:'',
                oldUrlKey:'',
                rules: {
                    name: [
                        {required: true, message: '请输入名称', trigger: 'blur'},
                        {min: 1, max: 20, message: '长度在 1 到 20 个字符', trigger: 'blur'}
                    ]
                }
            }
        },
        created() {

        },
        //挂载时候执行
        mounted(){
            this.getList();
        },
        methods: {
            getList(){
                //查询模板列表
                getShortUrlListApi(this.formInline).then((res) => {
                    console.log(res);
                    if (res.data.success) {
                        this.list = res.data.value.list;
                        this.recordsTotal =res.data.value.total;
                    } else {
                        this.$message({
                            message: res.data.message,
                            type: 'error'
                        });
                    }
                });
            },
            handleSizeChange(val) {
                this.formInline.pageSize = val;
                this.getList()
            },
            handleCurrentChange(val) {
                this.formInline.currentPage = val;
                this.getList()
            },
            add(){
                this.oldName=''
                this.oldUrlKey=''
                this.model = {
                    urlKey: '',
                    urlName:'',
                    url:''
                };
                this.showDialog = true;
            },
            edit(row){
                this.model = {
                    urlKey: row.urlKey,
                    urlName:row.urlName,
                    url:row.url
                };
                this.oldName=row.urlName
                this.oldUrlKey=row.urlKey
                this.showDialog = true;
            },
            save(){
                //名称判空
                if(this.model.url==''){
                    this.$message({
                        message: 'url不能为空',
                        type: 'error'
                    });
                    return;
                }
                if(this.model.urlName==''){
                    this.$message({
                        message: '名称不能为空',
                        type: 'error'
                    });
                    return;
                }
                if(this.oldUrlKey!=''){
                    //修改
                    if(this.model.urlName==this.oldName){
                        this.$message({
                            message: '修改长连接名称必须修改!',
                            type: 'error'
                        });
                        return;
                    }
                }
                this.loading=true;
                //保存
                saveShortLinkApi({urlName:this.model.urlName,link:this.model.url,urlKey:this.model.urlKey.replace("http://t.lechun.cc/","").replace("https://t.lechun.cc/","")}).then((res) => {
                    console.log(res);
                    this.loading=false;
                    if (res.data.success) {
                        this.showDialog = false;
                        this.getList();
                    } else {
                        this.$message({
                            message: res.data.message,
                            type: 'error'
                        });
                    }

                });
            },
            handleDel(row){
                //删除
                this.$confirm('删除不可撤销, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    deleteShortLinkApi({key:row.urlKey}).then((res) => {
                        console.log(res);
                        if (res.data.success) {
                            this.$message({
                                showClose: true,
                                message: '成功',
                                type: 'success'
                            });
                            this.getList();
                        } else {
                            this.$message({
                                message: res.data.message,
                                type: 'error'
                            });
                        }
                        this.showDialog = false;
                    });
                })
            },
            formatDate(datetime) {
                var date = new Date(datetime);
                var year = date.getFullYear(),
                    month = ("0" + (date.getMonth() + 1)).slice(-2),
                    sdate = ("0" + date.getDate()).slice(-2),
                    hour = ("0" + date.getHours()).slice(-2),
                    minute = ("0" + date.getMinutes()).slice(-2),
                    second = ("0" + date.getSeconds()).slice(-2);
                // 拼接
                var result = year + "-" + month + "-" + sdate + " " + hour + ":" + minute + ":" + second;
                // 返回
                return result;
            },
            returnHistory(){
                window.history.back()
            }
        }
    }
</script>
<style>
    .avatar-uploader .el-upload {
        border: 1px dashed #d9d9d9;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
    }

    .avatar-uploader .el-upload:hover {
        border-color: #409EFF;
    }

    .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 178px;
        height: 178px;
        line-height: 178px;
        text-align: center;
    }

    .avatar {
        width: 178px;
        height: 178px;
        display: block;
    }
</style>


// WEBPACK FOOTER //
// src/views/shortlink/shortlink.vue